// extracted by mini-css-extract-plugin
module.exports = {"protocol-dpa-fr":"_8FKMpsweKMzkDbsIqoqaxw=="};